// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_root_1fcus_15yju_99:not(#\\9){outline:none;shape-rendering:auto;overflow:visible;display:flex;inline-size:100%;max-inline-size:100%}.awsui_clickable_1fcus_15yju_108:not(#\\9){cursor:pointer}.awsui_precise_1fcus_15yju_112:not(#\\9){shape-rendering:geometricPrecision}.awsui_focus-outline_1fcus_15yju_116:not(#\\9){outline:none;pointer-events:none;fill:none;stroke:var(--color-border-item-focused-v8nq2m, #0073bb);stroke-width:2px;visibility:hidden}\n", ""]);
// Exports
module.exports = exports;
